import { render, staticRenderFns } from "./AddCaseVerification.vue?vue&type=template&id=93dcc53c&"
import script from "./AddCaseVerification.vue?vue&type=script&lang=js&"
export * from "./AddCaseVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports